export default __webpack_public_path__ + "static/media/undo.0e12ca18.png";